'use client';

export default function Error({
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	return (
		<div className="bg-bg text-fg flex min-h-dvh flex-col items-center justify-center">
			<h1 className="font-mono text-4xl font-light">ERROR</h1>
			<p className="text-label text-muted mt-4 font-mono tracking-wide uppercase">
				Something went wrong
			</p>
			<button
				type="button"
				onClick={reset}
				className="border-border text-label tracking-label text-fg hover:border-fg focus-visible:ring-fg mt-8 border px-6 py-3 font-mono uppercase transition-colors focus-visible:ring-1 focus-visible:outline-none"
			>
				Try Again
			</button>
		</div>
	);
}
